import { render } from "./GroupBars.vue?vue&type=template&id=6b9e98e8&scoped=true"
import script from "./GroupBars.vue?vue&type=script&lang=js"
export * from "./GroupBars.vue?vue&type=script&lang=js"

import "./GroupBars.vue?vue&type=style&index=0&id=6b9e98e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9e98e8"]])

export default __exports__